/**
 * Merge nested persisted `scope` languages/countries into the execute `scope`.
 * Top-level form arrays win when non-empty so autosaved `scope: { languages: ["en"] }`
 * cannot override the user's current German + Germany multi-selects.
 */
export function mergeCrossQueryPersistedScopeLanguagesCountries(scope, inc, { langsLength, countriesRawLength }) {
  if (!inc || typeof inc !== "object" || Array.isArray(inc)) return
  if (!langsLength && Array.isArray(inc.languages) && inc.languages.length) {
    scope.languages = inc.languages.map((x) => String(x).trim()).filter(Boolean)
  }
  if (!countriesRawLength && Array.isArray(inc.countries) && inc.countries.length) {
    scope.countries = inc.countries.map((c) => String(c).trim().toLowerCase()).filter(Boolean)
  }
}

/** CrossQuery runway: textarea / comma → scope.exclude_terms[] */
export function parseCrossQueryExcludeTermsText(raw) {
  if (raw == null || String(raw).trim() === "") return []
  const out = []
  for (const line of String(raw).split(/\r?\n/)) {
    const t = line.trim()
    if (!t) continue
    for (const part of t.split(/[,;]+/)) {
      const p = part.trim()
      if (p) out.push(p)
    }
  }
  return out
}
